import { Text, Button, Grid } from '@simplywallst/ui-core';
import EditSolid from '@simplywallst/ui-core/icons/EditSolid';
import { NotePad } from './styled';
import { useTranslation } from '@/hooks/useTranslation';

interface Props {
  handleAddNote: () => void;
  canCreateNote: boolean;
}

export const EmptyState = ({ handleAddNote, canCreateNote }: Props) => {
  const t = useTranslation();
  return (
    <Grid
      templateRows="auto auto auto"
      gap="8px"
      justifyItems="center"
      alignContent="center"
    >
      <NotePad />
      <Text typography="xSmall" color="white" textAlign="center">
        {t('app.component.notes.emptyState')}
      </Text>
      <Button
        data-cy-id="my-notes-empty-state-add"
        styleType="loud"
        alignIcon="left"
        onClick={handleAddNote}
        disabled={!canCreateNote}
      >
        <EditSolid /> {t('app.component.notes.addNote')}
      </Button>
    </Grid>
  );
};
